import { getPath } from '@/router/common'

const baseUrl = {
  title: '运单导入模板管理',
  path: 'ImportTemplate'
}

export default [
  {
    path: getPath('ImportTemplateMana', baseUrl),
    name: 'ImportTemplateMana',
    component: () => import(/* webpackChunkName: "ImportTemplateMana" */ '@/views/importTemplate/importTemplateMana/index.vue'),
    meta: {
      title: '运单导入模板管理'
    }
  },
  {
    path: getPath('UnitImportTemplateEdit', baseUrl),
    name: 'UnitImportTemplateEdit',
    component: () => import(/* webpackChunkName: "UnitImportTemplateEdit" */ '@/views/importTemplate/unitImportTemplateEdit/index.vue'),
    meta: {
      title: '运单导入模板管理新增'
    }
  },
  {
    path: getPath('ImportMiddleTemplateMana', baseUrl),
    name: 'ImportTemplate_ImportMiddleTemplateMana',
    component: () => import(/* webpackChunkName: "ImportTemplate_ImportMiddleTemplateMana" */ '@/views/importTemplate/importMiddleTemplateMana/index.vue'),
    meta: {
      title: '中转导入模板'
    }
  },
  {
    path: getPath('MiddleImportTemplateEdit', baseUrl),
    name: 'ImportTemplate_MiddleImportTemplateEdit',
    component: () => import(/* webpackChunkName: "ImportTemplate_MiddleImportTemplateEdit" */ '@/views/importTemplate/middleImportTemplateEdit/index.vue'),
    meta: {
      title: '中转导入模板新增/修改'
    }
  }
]
